export const GET_AREAS = 'GET_AREAS';
export const IS_FETCHING = 'IS_FETCHING';
export const ERROR_SERVER = 'ERROR_SERVER';
export const SET_ACCESS_AREAS_SELECTED = 'SET_ACCESS_AREAS_SELECTED';
export const CLEAN = 'CLEAN';
export const SET_FREE_ACCESS = 'SET_FREE_ACCESS';